<div *ngIf="isLoading$ | async" class="loading-container">
    <img src="assets/icons/B3-loading.svg" class="loading-logo">
</div>